import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton,ManText,ManCard } from '@craft-design-system/core-components-react';
import ifav from './ifav.png';
// import { ManCard} from '@craft-design-system/core-components-react';

import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

const Charging_power_normal = ({ value }) => {
  const [Charging_power_normal, set_Charging_power_normal] = useState(null);

//   //console.log('test',value)

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
      All time overview on average charging power vs. average battery temperature (system) for each charging cycle since start of data acquisition - If more than one vehicle is selected average values of all vehicles are displayed.
      </Popover.Body>
    </Popover>
  );


  useEffect(() => {
    try {
        set_Charging_power_normal(JSON.parse(value));
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    <ManCard className='card_battery' appearance="soft" outline="false">
      <ManText className="card-title-text" variant="component-l" as="span" size="l" 
       style={{}}>
     Charging Power (System) Vs Battery Temperature (System) during Normal Charging
      </ManText>
      <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
      <img className="man-logovv1" src={ifav}/>
      </OverlayTrigger>



      {Charging_power_normal && <Plot 
        data={Charging_power_normal.data} 
        layout={{
            ...Charging_power_normal.layout,
            autosize: true,
            responsive: true,
            margin: { t: 10, r: 10, l: 10, b: 10 }
        }}
        style={{ width: '100%', height: '85%' }}
        useResizeHandler={true}
    />}    
      </ManCard>
  );
};

Charging_power_normal.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Charging_power_normal;